"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _AccordionVariantItem = require("./AccordionVariantItem.style");

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var AccordionVariantItem = function AccordionVariantItem(props) {
  var _accordionVariant$car, _accordionVariant$car2, _accordionVariant$car3, _accordionVariant$car4, _element$current;

  var element = (0, _react.useRef)();

  var _ref = (0, _emotionTheming.useTheme)(),
      accordionVariant = _ref.accordionVariant;

  var item = props.item,
      activeTabIndex = props.activeTabIndex,
      index = props.index,
      activateTab = props.activateTab;
  var heading = item.heading,
      copy = item.copy;
  var isActive = activeTabIndex === index;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantCard, {
    onClick: function onClick() {
      return activateTab(index, heading);
    }
  }, /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantHeader, null, /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantTitle, null, heading), /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantIcon, {
    name: isActive ? accordionVariant === null || accordionVariant === void 0 ? void 0 : (_accordionVariant$car = accordionVariant.card) === null || _accordionVariant$car === void 0 ? void 0 : _accordionVariant$car.iconActive : accordionVariant === null || accordionVariant === void 0 ? void 0 : (_accordionVariant$car2 = accordionVariant.card) === null || _accordionVariant$car2 === void 0 ? void 0 : _accordionVariant$car2.iconInactive,
    size: accordionVariant === null || accordionVariant === void 0 ? void 0 : (_accordionVariant$car3 = accordionVariant.card) === null || _accordionVariant$car3 === void 0 ? void 0 : _accordionVariant$car3.iconSize,
    minWidth: accordionVariant === null || accordionVariant === void 0 ? void 0 : (_accordionVariant$car4 = accordionVariant.card) === null || _accordionVariant$car4 === void 0 ? void 0 : _accordionVariant$car4.iconSize
  })), /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantCollapse, {
    ref: element,
    isActive: isActive,
    scrollHeight: (_element$current = element.current) === null || _element$current === void 0 ? void 0 : _element$current.scrollHeight
  }, /*#__PURE__*/_react.default.createElement(_AccordionVariantItem.AccordionVariantBody, null, copy && /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    copySize: "xsmall",
    html: copy
  })))));
};

AccordionVariantItem.propTypes = {
  item: _propTypes.default.shape({
    heading: _propTypes.default.string,
    copy: _propTypes.default.string
  }),
  activeTabIndex: _propTypes.default.number,
  index: _propTypes.default.number,
  activateTab: _propTypes.default.func
};
AccordionVariantItem.defaultProps = {
  item: {
    heading: '',
    copy: ''
  },
  activeTabIndex: -1,
  index: 0,
  activateTab: function activateTab() {}
};
var _default = AccordionVariantItem;
exports.default = _default;